import { ChainId, ERC20Token, WAVAX } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  busd: new ERC20Token(
    ChainId.AVALANCHE,
    '0x9610b01AAa57Ec026001F7Ec5CFace51BfEA0bA6',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  nmx: new ERC20Token(
    ChainId.AVALANCHE,
    '0x67D27d1a9ea1d7F950cfDA31a389C5A44a004b69',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(ChainId.AVALANCHE, '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E', 6, 'USDC', 'USD Coin'),
  usdt: new ERC20Token(
    ChainId.AVALANCHE,
    '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
    6,
    'USDT.e',
    'Tether USD',
    'https://tether.to/',
  ),
  wavax: WAVAX[ChainId.AVALANCHE],
}
